import React, { useContext } from 'react';

import type { MediaUploadError } from './../../ricos-content';
import { RicosContext } from './../../ricos-context';
import type { VideoData } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { PluginProps } from './../../ricos-types';

import { VideoComponent } from './video-component';

export const Video: React.FC<PluginProps> = ({
  settings,
  componentData,
  updateAttributes,
  node,
  editor,
}) => {
  const { t } = useContext(RicosContext);
  const { loading, loadingPercentage, id } = node.attrs;
  return (
    <VideoComponent
      componentData={componentData as VideoData | { error: MediaUploadError }}
      t={t}
      config={settings}
      updateAttributes={updateAttributes}
      isLoading={loading}
      loadingPercentage={loadingPercentage}
      nodeId={id}
      editor={editor}
    />
  );
};
